import React, { useContext } from 'react'

import dynamic from 'next/dynamic'

import { MenuContext } from 'contexts/Menu'

import Logo from '@/Logo'
import Languages from '@/Languages'
import HamburgerMenu from '@/Buttons/HamburgerMenu'
import SearchButton from '@/Buttons/SearchButton'

import Container from '@/UI/Container'

import Navigation from './Navigation'

const MenuModal = dynamic(() => import('@/Modals/MenuModal'), { ssr: false, })

import {
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderUpper,
  StyledHeaderLower,
  StyledHeaderUpperContent,
} from './styles'
import GlobalButton from '@/Buttons/Global'

const Header = () => {
  const {
    menus,
    menuOpen,
    menuChangeHandler
  } = useContext(MenuContext)

  return (
    <StyledHeader
      isOpen={menuOpen}
    >
      <Container>
        <StyledHeaderContainer>
          <StyledHeaderUpper>
            <Logo />

            <StyledHeaderUpperContent>
              {
                menus.header &&
                !!menus.header.length &&
                <div className="desktop-nav">
                  <Navigation {...menus.header[0]}/>
                </div>
              }

              <div className="mobile-nav">
                <HamburgerMenu
                  menuOpen={menuOpen}
                  menuChangeHandler={menuChangeHandler}
                  cursor={{ type: 'hidden' }} />
              </div>

              <SearchButton />

              <div className="desktop-only">
                <GlobalButton />
                <Languages />
              </div>

            </StyledHeaderUpperContent>
          </StyledHeaderUpper>

          {
            menus.header &&
            !!menus.header.length &&
            <StyledHeaderLower className="desktop-nav">
              <Navigation {...menus.header[1]}/>
            </StyledHeaderLower>
          }

        </StyledHeaderContainer>
      </Container>
      <MenuModal />
    </StyledHeader>
  )
}

export default Header
